// extracted by mini-css-extract-plugin
export default {"root":"MonthPicker_root__BWu2S"};